var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRenameOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.0004 3c.497 0 .9.52.9 1.1613v15.6774c0 .6414-.403 1.1613-.9 1.1613-.4971 0-.9-.5199-.9-1.1613V4.1613c0-.6414.4029-1.1613.9-1.1613ZM7.816 5.7508c.6092-1.6612 2.9587-1.6612 3.5678 0l4.5611 12.4394a.8998.8998 0 0 1-.5351 1.1548.8998.8998 0 0 1-1.1548-.5351l-1.4823-4.0424H6.4272l-1.4823 4.0424a.8999.8999 0 0 1-1.1548.5351.9.9 0 0 1-.5351-1.1548L7.816 5.7508Zm-.7288 7.2167h5.0255l-2.4189-6.597c-.0132-.036-.027-.0457-.0334-.05A.1121.1121 0 0 0 9.6 6.305a.1121.1121 0 0 0-.0605.0157c-.0064.0042-.0202.0138-.0334.0499l-2.419 6.597Z",
  clipRule: "evenodd"
})));
export { SvgRenameOutline24 as ReactComponent };